<div [formGroup]="parentForm" class="k-textbox-container">
  <kendo-textbox 
    class="k-textbox" 
    #textbox1 
    (keyup)="handleInput($event, textbox1, textbox2, undefined)" 
    (paste)="handlePaste($event, textbox1)"
    [maxlength]="1"
    formControlName={{formControlName1}} 
    type="number"
    [attr.autocomplete]="'one-time-code'"
  ></kendo-textbox>
  <kendo-textbox 
    class="k-textbox" 
    #textbox2 
    (keyup)="handleInput($event, textbox2, textbox3, textbox1)" 
    (paste)="handlePaste($event, textbox2)"
    [maxlength]="1"
    formControlName={{formControlName2}} 
    type="number"
  ></kendo-textbox>
  <kendo-textbox 
    class="k-textbox" 
    #textbox3 
    (keyup)="handleInput($event, textbox3, textbox4, textbox2)" 
    (paste)="handlePaste($event, textbox3)"
    [maxlength]="1"
    formControlName={{formControlName3}} 
    type="number"
  ></kendo-textbox>
  <kendo-textbox 
    class="k-textbox" 
    #textbox4 
    (keyup)="handleInput($event, textbox4, textbox5, textbox3)"
    (paste)="handlePaste($event, textbox4)"
    [maxlength]="1"
    formControlName={{formControlName4}} 
    type="number"
  ></kendo-textbox>
  <kendo-textbox 
    class="k-textbox" 
    #textbox5 
    (keyup)="handleInput($event, textbox5, textbox6, textbox4)" 
    (paste)="handlePaste($event, textbox5)"
    [maxlength]="1"
    formControlName={{formControlName5}} 
    type="number"
  ></kendo-textbox>
  <kendo-textbox 
    class="k-textbox" 
    #textbox6 
    (keyup)="handleInput($event, textbox6, undefined, textbox5)"
    (paste)="handlePaste($event, textbox6)"
    [maxlength]="1" 
    formControlName={{formControlName6}} 
    type="number"
  ></kendo-textbox>
</div>